import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DialogControleFinancaMovimentoData } from '../../models/dialog-controle-financa-movimento-data';

@Component({
  selector: 'app-dialog-controle-financa-movimento',
  templateUrl: './dialog-controle-financa-movimento.component.html',
  styleUrls: ['./dialog-controle-financa-movimento.component.css']
})
export class DialogControleFinancaMovimentoComponent {
  public displayedColumns: string[] = [];

  public constructor(
    public dialogRef: MatDialogRef<DialogControleFinancaMovimentoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogControleFinancaMovimentoData
  ) {
    this.displayedColumns = this.data.noTipoMovimento == 'Saída' ?
      ['blSelecionado', 'noMovimentacao', 'vlMovimentacao', 'dtMovimentacao', 'dtVencimento'] :
      ['blSelecionado', 'noMovimentacao', 'vlMovimentacao', 'dtMovimentacao'];
  }

  public toggleAllSelection(event: MatCheckboxChange): void {
    const isChecked = event.checked;
    this.data.controleFinancaMovimentos.forEach((controleFinancaMovimento) => (controleFinancaMovimento.blSelecionado = isChecked));
  }

  public isAllSelected(): boolean {
    return this.data.controleFinancaMovimentos.every((controleFinancaMovimento) => controleFinancaMovimento.blSelecionado);
  }

  public isIndeterminate(): boolean {
    const selectedCount = this.data.controleFinancaMovimentos.filter((controleFinancaMovimento) => controleFinancaMovimento.blSelecionado).length;
    return selectedCount > 0 && selectedCount < this.data.controleFinancaMovimentos.length;
  }

  public onSelectionChange(): void {

  }

  public hasSelectedMovimentos(): boolean {
    return this.data.controleFinancaMovimentos.some((controleFinancaMovimento) => controleFinancaMovimento.blSelecionado);
  }

  public confirmSelection(): void {
    const selectedMovimentos = this.data.controleFinancaMovimentos.filter((controleFinancaMovimento) => controleFinancaMovimento.blSelecionado);
    this.dialogRef.close(selectedMovimentos);
  }

  public cancelDialog(): void {
    this.dialogRef.close(null);
  }
}